<template>
  <div>
    <div @click="propertyClicked" :style="{cursor: clickable ? 'pointer' : 'default'}">
      <div v-if="editableTextField">
        <span>{{ orginalValue }}</span>
        <v-icon class="ml-3 fin-color-primary-dark--text" @click="editMode=true">
          icon-edit
        </v-icon>
      </div>

      <v-row v-else-if="editableTextFieldName">
        <v-col cols="10">
          <div class="value-name">
            {{ name }}
          </div>
          <div class="value">
            <slot name="value">
              {{ orginalValue }}
            </slot>
          </div>
        </v-col>
        <v-col align="end" cols="2" v-if="!externalProviderLogin">
          <v-icon class="fin-color-primary-dark--text" @click="editMode=true">
            icon-edit
          </v-icon>
        </v-col>
      </v-row>

      <div v-else-if="bigValueSize">
        <h1 class="d-inline-flex">{{ orginalValue }}</h1>
        <slot class="subOriginalValue" name="subOriginalValue"/>
      </div>

      <div v-else>
        {{ orginalValue }}
      </div>
    </div>

    <fin-dialog v-model="editMode" content-class="fin-editable-property-dialog" :max-width="450">
      <template #title>
        {{ title }}
      </template>

      <v-form v-model="valid" class="pt-1" @submit.prevent="submit">
        <slot :change="changeInternal" :model="internal">Edit dialog</slot>
        <fin-error-msg :msg="error"/>
      </v-form>

      <template #actions>
        <v-btn class="mr-2" color="fin-color-primary-dark" outlined @click="editMode=false">Abbrechen</v-btn>
        <v-btn :disabled="disabled || !valid" :loading="loading" color="fin-color-primary-dark" dark tile
               @click="submit">{{ submitButton }}
        </v-btn>
      </template>
    </fin-dialog>
  </div>

</template>

<script>
import FinErrorMsg from '@/components/common/ErrorMsg'
import {handleError} from '@/js/finAwsErrorHandler'

export default {
  name: 'fin-editable-property',
  components: {FinErrorMsg},
  props: {
    name: {
      type: String
    },
    title: {
      type: String
    },
    submitButton: {
      type: String
    },
    value: {},
    orginalValue: {},
    editFunction: {
      type: Function
    },
    editableTextField: {
      type: Boolean,
      default: false
    },
    editableTextFieldName: {
      type: Boolean,
      default: false
    },
    bigValueSize: {
      type: Boolean,
      default: false
    },
    clickable: {
      type: Boolean,
      default: false
    },
    externalProviderLogin: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      editMode: false,
      valid: true,
      loading: false,
      error: '',
      internal: this.$props.value ? JSON.parse(JSON.stringify(this.$props.value)) : null
    }
  },
  computed: {
    disabled() {
      // use JSON.stringify to be able to compare it if internal/originalValue are objects
      return JSON.stringify(this.internal) === JSON.stringify(this.orginalValue)
    }
  },
  watch: {
    value(val) {
      this.internal = val ? JSON.parse(JSON.stringify(this.value)) : null
    }
  },
  methods: {
    submit() {
      this.loading = true
      if (this.editFunction) {
        this.editFunction(this.internal)
          .then(() => {
            this.onSaved()
          })
          .catch(this.setError)
      } else {
        this.setError('No logic to save')
      }
    },
    onSaved() {
      this.loading = false
      this.error = ''
      this.editMode = false
      this.$emit('input', this.internal)
    },
    setError(e) {
      this.loading = false
      this.error = handleError(e).msg
      console.error('EditableProperty TODO track and log', e)
    },
    show() {
      this.editMode = true
    },
    changeInternal(val) {
      this.internal = val
    },
    propertyClicked() {
      if (this.clickable) {
        this.$emit('propertyClicked')
      }
    },
  }
}
</script>

<style scoped lang="scss">
.value-name {
  font-size: 20px;
  font-weight: bold;
}

.value {
  font-size: 14px;
  font-weight: bold;
}
</style>
